module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/ES-d55a20d2bd787af332124117a48fa228.png";